<template>
    <div>
        <div class="container mt-4">
            <div class="row">
                <div class="col-8 offset-2">
                    <div class="card shadow-sm">
                        <div class="card-body">
                            <h5 class="card-title" v-if="order">
                                {{ $t('taxi.pages.confirmation.header', {'orderNumber': order.order_number}) }}
                            </h5>

                            <template v-if="order && false">
                                <div
                                    v-if="order.is_short_time === true"
                                    v-html="$t('taxi.pages.confirmation.berbus.short_time', {'orderNumber': order.order_number})"
                                ></div>
                                <div
                                    v-else-if="order.vehicle.is_eco === true"
                                    v-html="$t('taxi.pages.confirmation.berbus.paid_eco', {'orderNumber': order.order_number})"
                                ></div>
                                <div
                                    v-else-if="order.is_deferred_payment === true"
                                    v-html="$t('taxi.pages.confirmation.berbus.deferred', {'orderNumber': order.order_number})"
                                ></div>
                                <div v-else>
                                    <div v-if="order && payment">
                                        <span>Status Twojej płatności: </span><payment-status-badge :status="payment.status" class="inline" />
                                        <div
                                            v-if="payment.status === PAYMENT_STATUS_PAID"
                                            v-html="$t('taxi.pages.confirmation.berbus.paid', {'orderNumber': order.order_number})"
                                        ></div>
                                        <div
                                            v-if="payment.status === PAYMENT_STATUS_ERROR || payment.status === PAYMENT_STATUS_REJECTED"
                                            v-html="$t('taxi.pages.payment_error.details', {'orderNumber': order.order_number})"
                                        ></div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { PAYMENT_STATUS_PAID, PAYMENT_STATUS_ERROR } from '@/constants';
    import OrderRepository from '@repositories/OrderRepository';
    import PaymentStatusBadge from '../../components/PaymentStatusBadge';

    export default {
        components: {
            PaymentStatusBadge,
        },
        data() {
            return {
                order: null,
                payment: null,
                PAYMENT_STATUS_PAID: PAYMENT_STATUS_PAID,
                PAYMENT_STATUS_ERROR: PAYMENT_STATUS_ERROR,
            };
        },

        created() {
            this.$store.dispatch('berbus/reset');

            if (!window.APP.berbusOrderNumber) {
                this.$router.push({ name: 'home.index' });

                return;
            }

            OrderRepository.showByCookie('berbus', window.APP.berbusOrderNumber)
                .then(({data}) => {
                    this.order = data.data;
                    this.payment = this.order.payments.length ? data.data.payments[0] : null;
                })
                .catch(() => {
                    this.$router.push({ name: 'home.index' });
                });

            setInterval(() => {
                this.getOrder(window.APP.berbusOrderNumber);
            }, 5000);
        },

        methods: {
            getOrder(id) {
                if (this.order && this.order.status === 'paid_auto') {
                    return;
                }

                OrderRepository.showByCookie('berbus', id)
                    .then(({ data }) => {
                        this.order = data.data;
                        this.payment = this.order.payments.length ? data.data.payments[0] : null;
                    })
                    .catch(error => {
                        console.error(error);
                    });
            },
        },
    };
</script>
